import { InjectionToken, NgModule } from '@angular/core';

export interface SharedEnvironment {
  production: boolean;
  local: boolean;
  analyticsTrackingID: string;
  sentry: {
    dsn: string;
    environment: string;
  },
  apihost: {
    preFlight: string;
    postFlight: string;
    profile: string;
    admin: string;
    reportsMetaData: string;
    search: string;
  };
  apiroute: {
    preFlight: string;
    postFlight: string;
    profile: string;
    admin: string;
    reportsMetaData: string;
    search: string;
  };
  domainModuleRoutes: {
    profiles: string;
    preFlight: string;
    postFlight: string;
    admin: string;
    reportsMetaData: string;
    support: string;
    trainingVideos: string;
  };

  reportsServerAPIHost: string;
  appInsightsConfig: {
    instrumentationKey: string;
    cloudRoleName: string;
  };
  oidcsettings: {
    auto_clean_state_after_authentication: boolean;
    auto_userinfo: boolean;
    client_id: string;
    forbidden_route: string;
    hd_param: string;
    log_console_debug_active: boolean;
    log_console_warning_active: boolean;
    max_id_token_iat_offset_allowed_in_seconds: number;
    post_login_route: string;
    post_logout_redirect_uri: string;
    redirect_url: string;
    resource: string;
    response_type: string;
    scope: string;
    silent_renew: boolean;
    silent_renew_offset_in_seconds: number;
    silent_renew_url: string;
    start_checksession: boolean;
    storage: Storage;
    stsServer: string;
    trigger_authorization_result_event: boolean;
    unauthorized_route: string;
    useRefreshToken: boolean;
    triggerRefresh_WhenIdTokenExpired: boolean;
    ignoreNonceAfterRefresh: boolean;
  };
  flightdocsAuthUrl: string;
  flightdocsAuthRedirectUrl: string;
  fuelerlinxAuthUrl: string;
  fuelerlinxAuthRedirectUrl: string;
  universalWeatherAuthUrl: string;
  universalWeatherEnvironment: string;
  universalWeatherRedirectUrl: string;
  universalWeatherUIUrl: string;
  flightBridgeDirectLink: string;
}

export const SHARED_ENVIRONMENT = new InjectionToken('SHARED_ENVIRONMENT');

export const EMPTY_ENVIRONMENT: SharedEnvironment = {
  production: false,
  local: false,
  analyticsTrackingID: '',
  sentry: {
    dsn: '',
    environment: '',
  },
  apihost: {
    postFlight: '',
    preFlight: '',
    profile: '',
    admin: '',
    reportsMetaData: '',
    search: ''
  },
  apiroute: {
    postFlight: '',
    preFlight: '',
    profile: '',
    admin: '',
    reportsMetaData: '',
    search: ''
  },
  domainModuleRoutes: {
    profiles: '',
    preFlight: '',
    postFlight: '',
    admin: '',
    reportsMetaData: '',
    support: '',
    trainingVideos: ''
  },
  reportsServerAPIHost: '',
  appInsightsConfig: {
    instrumentationKey: '',
    cloudRoleName: ''
  },
  oidcsettings: {
    auto_clean_state_after_authentication: false,
    auto_userinfo: false,
    client_id: '',
    forbidden_route: '',
    hd_param: '',
    log_console_debug_active: false,
    log_console_warning_active: false,
    max_id_token_iat_offset_allowed_in_seconds: NaN,
    post_login_route: '',
    post_logout_redirect_uri: '',
    redirect_url: '',
    resource: '',
    response_type: '',
    scope: '',
    silent_renew: false,
    silent_renew_offset_in_seconds: NaN,
    silent_renew_url: '',
    start_checksession: false,
    storage: sessionStorage,
    stsServer: '',
    trigger_authorization_result_event: false,
    unauthorized_route: '',
    useRefreshToken: false,
    triggerRefresh_WhenIdTokenExpired: false,
    ignoreNonceAfterRefresh: false
  },
  flightdocsAuthUrl: '',
  flightdocsAuthRedirectUrl: '',
  fuelerlinxAuthUrl: '',
  fuelerlinxAuthRedirectUrl: '',
  universalWeatherAuthUrl: '',
  universalWeatherEnvironment: '',
  universalWeatherRedirectUrl: '',
  universalWeatherUIUrl: '',
  flightBridgeDirectLink: ''
};

@NgModule()
export class SharedEnvironmentModule {}
